import store from '@/store';
import { FETCH_CAROUSEL_SLIDES } from '@/store/actions/carousel.actions';

export const CarouselSlidesLoaded = (to, from, next) => {
  const pagesLoaded = store.getters.carouselSlidesLoaded;

  if (!pagesLoaded) {
    return store.dispatch(FETCH_CAROUSEL_SLIDES)
      .then(() => next())
      .catch(() => next({name: 'error'}))
  }

  return next();
};
